import OptionSubCategory from '../store/schema/OptionSubCategory';
import Option, { CoreOption } from '../store/schema/Option';

export function tryLoadAllFullOptionsSync(
    subcategory: OptionSubCategory
): Pick<Option, keyof CoreOption | 'fullOptionFormSettings'>[] {
    const loadedOptions = subcategory.options.map(option =>
        isOption(option)
            ? option
            : { ...option, fullOptionFormSettings: option.tryImportFullOptionFormSettingsSync() }
    );

    // If some options haven't yet loaded, return `null`
    return loadedOptions.some(({ fullOptionFormSettings }) => !fullOptionFormSettings)
        ? null
        : loadedOptions;
}

function isOption(option: any): option is Option {
    return 'fullOptionFormSettings' in option;
}
